import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from "@angular/router";
import * as pages from '../../core/routing/page-names';
import { inject, NgModule } from "@angular/core";
import { VendorScoreCardSurveyComponent } from "./vendor-score-card-survey/vendor-score-card-survey.component";
import { VendorScoreCardAdministrationComponent } from "./vendor-score-card-admin/vendor-score-card-administration/vendor-score-card-administration.component";
import { VendorScoreCardAdministrationGuard } from "src/app/base/guards/vendor-score-card-administration.guard";
import { VendorScoreCardVendorsComponent } from "./vendor-score-card-admin/vendor-score-card-vendors/vendor-score-card-vendors.component";
import { VendorScoreCardVendorsDataComponent } from "./vendor-score-card-admin/vendor-score-card-vendors-data/vendor-score-card-vendors-data.component";

const routes: Routes = [
  {
    path: pages.vendorScoreCardPageName,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: pages.vendorScoreCardSurveyPageName
      },
      {
        path: pages.vendorScoreCardAdministrationPageName,
        component: VendorScoreCardAdministrationComponent,
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(VendorScoreCardAdministrationGuard).canActivate(route, state)],
      },
      {
        path: pages.vendorScoreCardVendorsPageName,
        children: [
          {
            path: '',
            component: VendorScoreCardVendorsComponent,
            canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(VendorScoreCardAdministrationGuard).canActivate(route, state)],
          },
          {
            path: ":id",
            component: VendorScoreCardVendorsDataComponent,
            canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(VendorScoreCardAdministrationGuard).canActivate(route, state)],
          }
        ],
        
      }
    ]
  },
  {
    path: pages.vendorScoreCardSurveyPageName,
    component: VendorScoreCardSurveyComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VendorScoreCardRoutingModule { }